// src/components/Sidebar/SidebarNode.js

import React from 'react';

const SidebarNode = ({ type, label, icon, description }) => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      onDragStart={(event) => onDragStart(event, type)}
      draggable
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        margin: '5px 0',
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        cursor: 'grab',
      }}
    >
      {icon ? (
        typeof icon === 'string' ? (
          <img
            src={icon}
            alt={label}
            style={{ width: '40px', height: '40px', marginRight: '8px' }}
          />
        ) : (
          <icon.type
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
        )
      ) : (
        <div
          style={{
            width: '24px',
            height: '24px',
            marginRight: '8px',
            backgroundColor: '#ccc',
          }}
        />
      )}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span>{label}</span>
        {description && (
          <span style={{ fontSize: '10px', color: '#666', marginTop: '4px' }}>
            {description}
          </span>
        )}
      </div>
    </div>
  );
};

export default SidebarNode;
